export class CarBrand {
    public name:string;
    public logo:string;
    public moto:string;
    public websiteLink:string;
    public configuratorLink:string;


    constructor(name: string, logo: string, moto: string, websiteLink: string, configuratorLink: string) {
        this.name = name;
        this.logo = logo;
        this.moto = moto;
        this.websiteLink = websiteLink;
        this.configuratorLink = configuratorLink;
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/new-car/presentation/brand/CarBrand.ts